import React, { Component } from 'react';
import '../myutils';
import { AppBar, translate, Logout } from 'react-admin';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import QuickCallButton from '../buttons/QuickCallButton';
import { Redirect } from 'react-router';
import { configAPI } from '../config'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import NotificationsActive from '@material-ui/icons/NotificationsActive';
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import AttachMoney from '@material-ui/icons/AttachMoney';
import AccountCircle from '@material-ui/icons/AccountCircle';
import CloseIcon from '@material-ui/icons/Close';
import { DialogContent, DialogTitle, Paper, TextField } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


const styles = theme => ({
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    menuItem: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& $primary, & $icon': {
                color: theme.palette.common.white,
            },
        },
    },
    primary: {},
    icon: {},
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
    spacer2: {
        flex: 0.1,
    },
});


class CustomAppBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false, openADMINUsersDialog: false, openSelectUsersDialog: false, userList: [], ADMINmenu: '', password: '', openPassword: false,
            userArray: [], userName: '', selectedUserName: '', openApprove: false, ADMINnewPassword: '', ADMINpassword: '', userPassowrd: '', anchorEl: null,
            showPasswordError: false, MAINoldPassword: '', MAINnewPassword: ''
        }
    }


    handleUserMenuClick = event => {
        if (sessionStorage.C.encodeDecode() === 'ADMIN') this.setState({ anchorEl: event.currentTarget });
    };
    handleUserMenuClose = () => {
        this.setState({ anchorEl: null });
    };


    checkUsers() {
        this.setState({ userList: [] });
        const { translate } = this.props;
        const request = new Request(configAPI.api.prod + '/GetIVR2Dir?&path=ivr2:/AutherizedUsers&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
        });
        return fetch(request)
            .then(response => { return response.json(); })
            .then(IVRDIR => {
                if (IVRDIR.responseStatus === 'ERROR') {
                    sessionStorage.setItem('C', 'ADMIN'.encodeDecode());
                    sessionStorage.setItem('D', 'undefinedORempty'.encodeDecode());;
                    this.setState({ selectedUserName: translate('trans.ADMIN') });
                }
                else if (IVRDIR.files.length > 1) {
                    var templist = [];
                    IVRDIR.files.forEach(file => {
                        if (file.name !== 'ADMIN.txt') templist.push(file.name.replace(/\.[^/.]+$/, ""))
                    });
                    this.setState({ userList: templist });
                }

            });
    }

    changeUserName = (e) => {
        let userName = e.target.value.replace(/[^\w\s]/gi, "");
        this.setState({ userName: userName })
    };
    changeADMINpassword = (e) => {
        let ADMINpassword = e.target.value.replace(/[^\w\s]/gi, "");
        this.setState({ ADMINpassword: ADMINpassword })
    };
    changeUserPassword = (e) => {
        let userPassowrd = e.target.value.replace(/[^\w\s]/gi, "");
        this.setState({ userPassowrd: userPassowrd })
    };
    changePassword = (e) => {
        let password = e.target.value.replace(/[^\w\s]/gi, "");
        this.setState({ password: password })
    };

    changeADMINnewPassword = (e) => {
        let ADMINnewPassword = e.target.value.replace(/[^\w\s]/gi, "");
        this.setState({ ADMINnewPassword: ADMINnewPassword })
    };

    changeMAINoldPassword = (e) => {
        let MAINoldPassword = e.target.value.replace(/[^\w\s]/gi, "");
        this.setState({ MAINoldPassword: MAINoldPassword })
    };

    changeMAINnewPassword = (e) => {
        let MAINnewPassword = e.target.value.replace(/[^\w\s]/gi, "");
        this.setState({ MAINnewPassword: MAINnewPassword })
    };

    updateADMINpassword = (e) => {

        const request = new Request(configAPI.api.prod + '/DownloadFile?&path=ivr2:/AutherizedUsers/ADMIN.txt&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
        });
        return fetch(request).then(data => data.text())
            .then(data => {
                if (data === 'Requested file does not exist') {
                    const request = new Request(configAPI.api.prod + 'UpdateExtension?token=' + sessionStorage.B.encodeDecode() + '&path=ivr2:/AutherizedUsers');
                    return fetch(request)
                        .then(response => response.json())
                        .then(json => {
                            if (json.responseStatus === 'OK') {
                                const request = new Request(configAPI.api.prod + '/UploadTextFile?&token=' + sessionStorage.B.encodeDecode() + '&what=ivr2:AutherizedUsers/ADMIN.txt&contents=*ADMIN*{' + this.state.ADMINpassword + '}')
                                return fetch(request)
                                    .then(resp => {
                                        this.checkUsers();
                                    })
                            }
                        })
                }
                else if (data.indexOf('{' + this.state.ADMINpassword + '}') > -1) {
                    const request = new Request(configAPI.api.prod + '/UploadTextFile?&token=' + sessionStorage.B.encodeDecode() + '&what=ivr2:AutherizedUsers/ADMIN.txt&contents=*ADMIN*{' + this.state.ADMINnewPassword + '}')
                    return fetch(request)
                        .then(resp => {
                            this.checkUsers();
                        })
                }
                this.setState({ openADMINUsersDialog: false });
            })
    }

    updateMAINpassword = (e) => {
        const ReqGetSession = new Request(configAPI.api.prod + 'Login?username=' + sessionStorage.userDID + '&password=' + this.state.MAINoldPassword);
        fetch(ReqGetSession)
            .then(response => response.json())
            .then(session => {
                var token = session.token.encodeDecode();
                sessionStorage.setItem('B', token);
                if (session.responseStatus === 'OK') {
                    const ReqGetSession = new Request(configAPI.api.prod + 'SetPassword?password=' + this.state.MAINoldPassword + '&newPassword=' + this.state.MAINnewPassword + '&token=' + sessionStorage.B.encodeDecode());
                    fetch(ReqGetSession)
                        .then(response => response.json())
                        .then(session => {
                            if (session.responseStatus === 'OK') {
                                this.setState({ openADMINUsersDialog: false });
                            }
                            else {
                                this.setState({ showPasswordError: true });
                            }
                        })
                }
                else {
                    this.setState({ showPasswordError: true });
                }
            })
    }

    createUser = (e) => {

        const request = new Request(configAPI.api.prod + '/GetIVR2Dir?&path=ivr2:/AutherizedUsers&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
        });
        return fetch(request)
            .then(response => { return response.json(); })
            .then(IVRDIR => {
                if (IVRDIR.responseStatus === 'ERROR') {
                    const request = new Request(configAPI.api.prod + 'UpdateExtension?token=' + sessionStorage.B.encodeDecode() + '&path=ivr2:/AutherizedUsers');
                    return fetch(request)
                        .then(response => response.json())
                        .then(json => {
                            if (json.responseStatus === 'OK') {
                                const request = new Request(configAPI.api.prod + '/UploadTextFile?&token=' + sessionStorage.B.encodeDecode() + '&what=ivr2:AutherizedUsers/ADMIN.txt&contents=*ADMIN*{}')
                                return fetch(request)
                                    .then(resp => {
                                        this.checkUsers();
                                        const request = new Request(configAPI.api.prod + '/UploadTextFile?&token=' + sessionStorage.B.encodeDecode() + '&what=ivr2:AutherizedUsers/' + this.state.userName + '.txt&contents=*' + this.state.userName + '*{' + this.state.userPassowrd + '}')
                                        return fetch(request)
                                            .then(resp => {
                                                this.checkUsers();
                                            })
                                    })
                            }
                        })

                }

                else {
                    if (this.state.userList.indexOf(this.state.userName) < 0) {
                        const request = new Request(configAPI.api.prod + '/UploadTextFile?&token=' + sessionStorage.B.encodeDecode() + '&what=ivr2:AutherizedUsers/' + this.state.userName + '.txt&contents=*' + this.state.userName + '*{' + this.state.userPassowrd + '}')
                        return fetch(request)
                            .then(resp => {
                                this.checkUsers();
                            })
                    }
                    else {
                        const request = new Request(configAPI.api.prod + '/DownloadFile?path=ivr2:/AutherizedUsers/' + this.state.userName + '.txt&token=' + sessionStorage.B.encodeDecode(), {
                            headers: new Headers({
                                'Content-Type': 'text/json'
                            }),
                            method: 'GET'
                        });
                        fetch(request).then(data => data.text())
                            .then(data => {
                                var contents = data.replace(/{.*?}/g, '{' + this.state.userPassowrd + '}');
                                const request = new Request(configAPI.api.prod + '/UploadTextFile?&token=' + sessionStorage.B.encodeDecode() + '&what=ivr2:AutherizedUsers/' + this.state.userName + '.txt&contents=' + contents)
                                return fetch(request)
                                    .then(resp => {
                                        this.checkUsers();
                                    })
                            })
                    }
                }
            })
    }

    resetSystem = (e) => {
        const request = new Request(configAPI.api.prod + '/FileAction?action=delete&token=' + sessionStorage.B.encodeDecode() + '&what=ivr2:/AutherizedUsers', {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
        });

        fetch(request).then(data => data.text())
            .then(data => {
                this.setState({ openADMINUsersDialog: false });
            });
    };

    deleteUser = (e) => {
        const request = new Request(configAPI.api.prod + '/FileAction?action=delete&token=' + sessionStorage.B.encodeDecode() + '&what=ivr2:/AutherizedUsers/' + this.state.userName + '.txt', {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
        });

        fetch(request).then(data => data.text())
            .then(data => {
                this.checkUsers();
                this.setState({ openApprove: false });
            })
    };

    selectUser = () => {

        const request = new Request(configAPI.api.prod + '/DownloadFile?path=ivr2:/AutherizedUsers/' + this.state.userName + '.txt&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
        });
        return fetch(request).then(data => data.text())
            .then(data => {
                if (data !== "Requested file does not exist") {
                    var userPassowrd = data.match(/{.*}/);
                    userPassowrd[0] = userPassowrd[0].replace(/[{}]/g, '');
                    if (userPassowrd[0] === this.state.password) {
                        sessionStorage.setItem('C', this.state.userName.encodeDecode());
                        sessionStorage.setItem('D', data.encodeDecode());
                        this.setState({ openSelectUsersDialog: false, openPassword: false, selectedUserName: this.state.userName });
                        this.props.push('/IVR?');
                    }
                    else this.setState({ openPassword: false, openSelectUsersDialog: true, userName: '' });
                }
            }, (error) => {
                if (error) {
                    this.setState({ openPassword: false, openSelectUsersDialog: true, userName: '' });
                    console.log('error')
                    console.log(error)
                }
            });
    }

    loadUser(user) {
        this.setState({ userName: user })
        const request = new Request(configAPI.api.prod + '/DownloadFile?path=ivr2:/AutherizedUsers/' + user + '.txt&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
                'Content-Type': 'text/json'
            }),
            method: 'GET'
        });
        return fetch(request).then(data => data.text())
            .then(data => {
                var userPassowrd = data.match(/{.*}/);
                userPassowrd[0] = userPassowrd[0].replace(/[{}]/g, '');
                this.setState({ userPassowrd: userPassowrd[0] });
            })
    }


    componentWillMount() {
        if (sessionStorage.B !== undefined) {
            this.setState({ userList: [] });
            const { translate } = this.props;
            const request = new Request(configAPI.api.prod + '/GetIVR2Dir?&path=ivr2:/AutherizedUsers&token=' + sessionStorage.B.encodeDecode(), {
                headers: new Headers({
                    'Content-Type': 'text/json'
                }),
                method: 'GET'
            });
            return fetch(request)
                .then(response => { return response.json(); })
                .then(IVRDIR => {
                    if (IVRDIR.responseStatus === 'ERROR') {
                        sessionStorage.setItem('C', 'ADMIN'.encodeDecode());
                        sessionStorage.setItem('D', 'undefinedORempty'.encodeDecode());;
                        this.setState({ selectedUserName: translate('trans.ADMIN') });
                    }
                    else {
                        if (IVRDIR.files.length > 1) {
                            var templist = [];
                            IVRDIR.files.forEach(file => {
                                if (file.name !== 'ADMIN.txt') templist.push(file.name.replace(/\.[^/.]+$/, ""))
                            });
                            this.setState({ userList: templist });
                            const request = new Request(configAPI.api.prod + '/DownloadFile?path=ivr2:/AutherizedUsers/ADMIN.txt&token=' + sessionStorage.B.encodeDecode(), {
                                headers: new Headers({
                                    'Content-Type': 'text/json'
                                }),
                                method: 'GET'
                            });
                            fetch(request).then(data => data.text())
                                .then(data => {
                                    if (data.indexOf('{' + sessionStorage.ADMINpassword + '}') > -1) {
                                        sessionStorage.setItem('C', 'ADMIN'.encodeDecode());
                                        sessionStorage.setItem('D', 'undefinedORempty'.encodeDecode());;
                                        this.setState({ selectedUserName: translate('trans.ADMIN'), AUTHEXTS: '' });
                                    }
                                    else this.setState({ openSelectUsersDialog: true });
                                    sessionStorage.removeItem('ADMINpassword');
                                })
                        }
                        else {
                            sessionStorage.setItem('C', 'ADMIN'.encodeDecode());
                            sessionStorage.setItem('D', 'undefinedORempty'.encodeDecode());;
                            this.setState({ selectedUserName: translate('trans.ADMIN') });
                        }
                    }
                })
        }
    }

    componentDidMount() {
        if (sessionStorage.B !== undefined) {
            const ReqGetSession = new Request(configAPI.api.prod + 'GetSession?token=' + sessionStorage.B.encodeDecode());
            fetch(ReqGetSession)
                .then(response => response.json())
                .then(session => {
                    if (session.responseStatus === 'OK') {
                        this.setState({ units: Number((session.units).toFixed(1)) });
                        this.setState({ userID: session.username, organization: session.organization });
                        sessionStorage.setItem('userDID', session.username);
                        sessionStorage.setItem('creditFile', session.creditFile);
                        // sessionStorage.setItem('organization', session.organization);
                        // sessionStorage.setItem('units', Number((session.units).toFixed(1)));
                    } else return (<Redirect to="/route/to/redirect" />);
                });
        }
    }

    logoutUser() {
        // צריך להוסיף קריאה לlogout בAPI.
        if (!sessionStorage || !sessionStorage.B) return;
        if (sessionStorage.B) {
            // try to du logout
            const ReqGetSession = new Request(configAPI.api.prod + 'Logout?token=' + sessionStorage.B.encodeDecode());
            fetch(ReqGetSession)
                .then(response => response.json())
                .finally(() => {
                    sessionStorage.clear();
                    window.location = window.location.origin + window.location.pathname;
                });
        }
    }

    render() {
        const props = this.props;
        const { classes } = this.props;
        const { translate } = this.props;
        const { anchorEl } = this.state;
        const openAnchorEl = Boolean(anchorEl);
        const options = [
            'addRemoveUsers',
            // 'deleteUser',
            'updatePasswords',
            'resetSystem'
        ];
        const ITEM_HEIGHT = 48;

        return (
            <>
                <AppBar {...props}
                    style={{ backgroundColor: '#f5f5f5', color: 'gray' }}
                    userMenu={<Logout onClick={this.logoutUser} style={{ color: 'grey' }} />} >
                    <span className={classes.spacer} />
                    {translate('trans.betaVersion')}
                    <span className={classes.spacer2} />
                    {/* <a id="admin-link-oldsite" href="https://private.call2all.co.il/ym/" style={{ color: 'grey' }}>*{translate('trans.oldSite')}*</a> */}
                    <a id="admin-link-oldsite" href={configAPI.api.prod.replace(/\/api\/?$/, '/')} style={{ color: 'grey' }}>*{translate('trans.oldSite')}*</a>
                    <span className={classes.spacer} />
                    <Typography variant="display1" color="inherit" className={classes.flex}>
                        <span style={{ float: "right", verticalAlign: 'middle' }}>
                            {this.state.organization}
                        </span>
                    </Typography>
                    <span className={classes.spacer} />
                    <span className={classes.spacer} />
                    <Chip color="default" avatar={<Avatar><AttachMoney /></Avatar>} label={translate('trans.units_left') + ':' + this.state.units} />
                    <span className={classes.spacer2} />
                    {/* <span className={classes.spacer} /> */}
                    <Chip color="default" avatar={<Avatar style={{ cursor: 'pointer' }} onClick={this.handleUserMenuClick}><AccountCircle /></Avatar>} label={translate('trans.currentUser') + this.state.selectedUserName} />
                    <span className={classes.spacer2} />
                    <Button
                        style={{ backgroundColor: '#bdbdbd' }}
                        variant="fab"
                        mini
                        color='primary'
                        label={translate(`resources.Softphone.quick_call`)}
                        onClick={() => { if (this.state.units < 100) this.setState({ open: true }) }}
                    >
                        <Badge badgeContent={(this.state.units < 100) ? "1" : "0"} color="default">
                            <NotificationsActive style={{ color: "white" }} />
                        </Badge>
                    </Button>
                    <span className={classes.spacer2} />
                    <QuickCallButton />
                    <span className={classes.spacer2} />
                    <Typography variant="title" color="inherit" className={classes.flex}>
                        <span style={{ float: "right", verticalAlign: 'middle' }}>
                            {/* {translate('trans.userDID')} */}
                            {this.state.userID}
                        </span>
                    </Typography>
                    <span className={classes.spacer2} />
                    <Menu
                        id="long-menu"
                        anchorEl={anchorEl}
                        open={openAnchorEl}
                        onClose={this.handleUserMenuClose}
                        PaperProps={{
                            style: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                                width: 200,
                            },
                        }}
                    >
                        {options.map(option => (
                            <MenuItem key={option} onClick={() => this.setState({ openADMINUsersDialog: true, ADMINmenu: option })}>
                                {translate('trans.' + option)}
                            </MenuItem>
                        ))}
                    </Menu>
                    <Dialog
                        open={this.state.open}
                        onClose={(e) => this.setState({ open: false })}
                        aria-labelledby="form-dialog-title"
                        onBackdropClick={(e) => e.stopPropagation()}
                    >
                        <IconButton color="inherit" onClick={(e) => this.setState({ open: false })} aria-label="Close" style={{ float: 'right' }}>
                            <CloseIcon />
                        </IconButton>
                        <DialogContent>
                            <Typography variant="body2" color="inherit" >
                                <span style={{ float: "none", verticalAlign: 'middle' }}>{translate('trans.lowUnits')}{this.state.units}</span>
                            </Typography>
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={this.state.openADMINUsersDialog}
                        onClose={(e) => this.setState({ openADMINUsersDialog: false })}
                        aria-labelledby="form-dialog-title"
                        scroll={'paper'}
                        onBackdropClick={(e) => e.stopPropagation()}
                    >
                        <IconButton color="inherit" onClick={(e) => this.setState({ openADMINUsersDialog: false })} aria-label="Close" style={{ float: 'right' }}>
                            <CloseIcon />
                        </IconButton>
                        <DialogTitle>
                            {translate('trans.' + this.state.ADMINmenu)}
                        </DialogTitle>
                        <DialogContent>
                            {(this.state.ADMINmenu === 'updatePasswords') && (<>
                                <Paper>
                                    <DialogTitle>
                                        {translate('trans.updateADMINpassword')}
                                    </DialogTitle>
                                    <br />
                                    <TextField
                                        onChange={this.changeADMINpassword}
                                        label={translate('trans.ADMINoldPassword')}
                                        //   error={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1))}
                                        //   helperText={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1)) ? translate('trans.replaceFile') : ''}
                                        className={classes.textField}
                                        margin="normal"
                                        defaultValue={''}
                                        value={this.state.ADMINpassword} />
                                    <TextField
                                        onChange={this.changeADMINnewPassword}
                                        label={translate('trans.ADMINnewPassword')}
                                        className={classes.textField}
                                        margin="normal"
                                        //   error={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1))}
                                        //   helperText={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1)) ? translate('trans.replaceFile') : ''}
                                        defaultValue={''}
                                        value={this.state.ADMINnewPassword} />
                                    <br />
                                    <Button color="primary" onClick={this.updateADMINpassword}>{translate('trans.updateADMINpassword')}</Button>
                                </Paper>
                                <br />
                                <Paper>
                                    <DialogTitle>
                                        {translate('trans.updateMAINpassword')}
                                    </DialogTitle>
                                    <br />
                                    <TextField
                                        onChange={this.changeMAINoldPassword}
                                        label={translate('trans.MAINoldPassword')}
                                        //   error={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1))}
                                        //   helperText={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1)) ? translate('trans.replaceFile') : ''}
                                        className={classes.textField}
                                        margin="normal"
                                        defaultValue={''}
                                        value={this.state.MAINoldPassword} />
                                    <TextField
                                        onChange={this.changeMAINnewPassword}
                                        label={translate('trans.MAINnewPassword')}
                                        className={classes.textField}
                                        margin="normal"
                                        //   error={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1))}
                                        //   helperText={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1)) ? translate('trans.replaceFile') : ''}
                                        defaultValue={''}
                                        value={this.state.MAINnewPassword} />
                                    <br />
                                    <Button color="primary" onClick={this.updateMAINpassword}>{translate('trans.updateMAINpassword')}</Button>
                                </Paper>
                            </>)}

                            {(this.state.ADMINmenu === 'addRemoveUsers') && (<>
                                <Button color="primary" onClick={() => { if (this.state.userName !== 'ADMIN') this.createUser() }}>{translate('trans.createUser')}</Button>
                                <Button color="primary" onClick={() => this.setState({ openApprove: true })} disabled={this.state.userList.length < 1} >{translate('trans.deleteUser')}</Button>
                                <br />
                                <TextField
                                    onChange={this.changeUserName}
                                    label={translate('trans.newUser')}
                                    className={classes.textField}
                                    margin="normal"
                                    //   error={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1))}
                                    //   helperText={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1)) ? translate('trans.replaceFile') : ''}
                                    defaultValue={''}
                                    value={this.state.userName} />
                                <TextField
                                    onChange={this.changeUserPassword}
                                    label={translate('trans.newPassword')}
                                    className={classes.textField}
                                    margin="normal"
                                    //   error={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1))}
                                    //   helperText={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1)) ? translate('trans.replaceFile') : ''}
                                    defaultValue={''}
                                    value={this.state.userPassowrd} />
                                {/* </>)} */}
                                {/* {(this.state.ADMINmenu === 'deleteUser') && (<> */}
                                {this.state.userList.map((user, i) => (
                                    <div>
                                        <MenuItem className={classes.menuItem} onClick={() => this.loadUser(user)}>
                                            {user}
                                        </MenuItem>
                                    </div>
                                ))}
                            </>)}
                            {(this.state.ADMINmenu === 'resetSystem') && (<>
                                <h1>
                                    {translate('trans.resetSystemExplain')}
                                </h1>
                                <Button onClick={(e) => this.setState({ openApprove: false })} color="primary">
                                    {translate(`trans.cancel`)}
                                </Button>
                                <Button onClick={this.resetSystem} color="primary" autoFocus>
                                    {translate(`trans.ok`)}
                                </Button>
                                <br />

                            </>)}
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={this.state.openSelectUsersDialog}
                        // onClose={(e) => this.setState({ openSelectUsersDialog: false })}
                        aria-labelledby="form-dialog-title"
                        scroll={'paper'}
                    // onBackdropClick={(e) => e.stopPropagation()}
                    >
                        <DialogTitle>
                            {translate('trans.SelectUserTitle')}
                        </DialogTitle>
                        <DialogContent>
                            {this.state.userList.map((user, i) => (
                                <div>
                                    <MenuItem onClick={() => { this.setState({ userName: user, openPassword: true }); }}>
                                        {user}
                                    </MenuItem>
                                </div>
                            ))}
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={this.state.openPassword}
                        // onClose={this.setState({openApprove:false})}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{translate(`trans.userPassword`)}</DialogTitle>
                        <DialogActions>
                            <TextField
                                onChange={this.changePassword}
                                label={translate('trans.password')}
                                className={classes.textField}
                                margin="normal"
                                //   error={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1))}
                                //   helperText={((sessionStorage.AllFiles.indexOf('/' + bfname + '.') > -1) && (this.state.updatedAcceptedFiles[index] === undefined)) || ((this.state.updatedAcceptedFiles[index] !== undefined) && (sessionStorage.AllFiles.indexOf('/' + this.state.updatedAcceptedFiles[index] + '.') > -1)) ? translate('trans.replaceFile') : ''}
                                defaultValue={''}
                                value={this.state.password}
                            />
                            <Button onClick={(e) => this.setState({ openPassword: false })} color="primary">
                                {translate(`trans.cancel`)}
                            </Button>
                            <Button onClick={this.selectUser} color="primary" autoFocus>
                                {translate(`trans.ok`)}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={this.state.openApprove}
                        // onClose={this.setState({openApprove:false})}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{translate(`trans.approveDelete`)}</DialogTitle>
                        <DialogActions>
                            <Button onClick={(e) => this.setState({ openApprove: false })} color="primary">
                                {translate(`trans.cancel`)}
                            </Button>
                            <Button onClick={(e) => this.deleteUser()} color="primary" autoFocus>
                                {translate(`trans.ok`)}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={this.state.showPasswordError}
                        // onClose={this.setState({openApprove:false})}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{translate(`trans.passwordError`)}</DialogTitle>
                        <DialogActions>
                            <Button onClick={(e) => this.setState({ showPasswordError: false })} color="primary">
                                {translate(`trans.ok`)}
                            </Button>
                        </DialogActions>
                    </Dialog>

                </AppBar>
            </>
        )
    }
}

CustomAppBar.propTypes = {
    push: PropTypes.func,
}

export default connect(null, {
    push,
})(withStyles(styles)(translate(CustomAppBar)));
